const meta = {
  storage: 'Control concepts',
  shaping: 'Metric shaping',
  sampling: 'Trace sampling',
  consumption: 'Log controls',
};

export default meta;
